import React, { FC, useState } from 'react'
import { ConfigProvider as ThemeProviders, theme } from 'antd'
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import locale from 'antd/es/date-picker/locale/th_TH';
import localeData from 'dayjs/plugin/localeData'
import dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import weekday from 'dayjs/plugin/weekday'
import 'dayjs/locale/th';
import thTH from 'antd/locale/th_TH';

dayjs.locale('th');
dayjs.extend(buddhistEra)
dayjs.extend(customParseFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)

const { darkAlgorithm } = theme

interface Props {
    children: React.ReactNode;
}

const ConfigProvider: FC<Props> = ({ children }) => {
    const prefixState = useSelector((state: ApplicationState) => state.prefix)
    const primary = prefixState?.info?.themeColor?.primary || '#005de7'

    const generateDarkerColor = (hexColor: string, factor: number): string => {
        // แปลง hex เป็น RGB
        const rgb = parseInt(hexColor.slice(1), 16);
        let r = (rgb >> 16) & 0xff;
        let g = (rgb >> 8) & 0xff;
        let b = (rgb >> 0) & 0xff;

        // ลดความสว่างของสี
        r = Math.floor(r * factor);
        g = Math.floor(g * factor);
        b = Math.floor(b * factor);

        // รวมกลับเป็น hex
        // eslint-disable-next-line no-mixed-operators
        const newHexColor = `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;

        return newHexColor;
    };

    return (
        <ThemeProviders
            locale={thTH}
            theme={{
                // algorithm: darkAlgorithm,
                hashed: false,
                // token: themeSetting
                token: {
                    borderRadius: 12,
                    colorBgBase: '#121416',
                    colorBgContainer: '#0d0f10',
                    colorBorder: '#434343',
                    colorBorderSecondary: '#1b1d1f',
                    colorLink: primary,
                    colorLinkActive: generateDarkerColor(primary, 0.8),
                    colorLinkHover: generateDarkerColor(primary, 0.8),
                    colorPrimary: primary,
                    colorText: 'rgba(255, 255, 255, 0.88)',
                    colorTextQuaternary: 'rgba(255, 255, 255, 0.25)',
                    colorTextSecondary: 'rgba(255, 255, 255, 0.65)',
                    colorTextTertiary: 'rgba(255, 255, 255, 0.45)',
                    colorTextDescription: 'rgba(255, 255, 255, 0.75)',
                    colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
                    colorTextHeading: 'rgba(255, 255, 255, 0.88)',
                    colorTextLabel: 'rgba(255, 255, 255, 0.65)',
                    colorTextPlaceholder: 'rgba(255, 255, 255, 0.25)',
                    controlHeight: 48,
                    fontFamily: "'IBM Plex Sans Thai', 'sans-serif'",
                    fontSize: 16,
                    lineHeight: 1
                },
                components: {
                    Alert: {
                        algorithm: darkAlgorithm,
                        colorText: 'rgba(255, 255, 255, 0.88)',
                    },
                    Segmented: {
                        itemSelectedBg: primary,
                    },
                }
            }}>
            {children}
        </ThemeProviders>
    )
}

export default ConfigProvider